import './AllOrdreMissions.scss';

import React, {useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import OrdreMission from '../../../Components/Docs/OdreMission';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { StatutsOrdreMision } from '../../../data/Interfaces';
// import { useGlobalContext } from '../../Contexts/suiviMission/GlobalContext';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { calculateWorkingDaysBetweenDates, getNomPrenomClearFromPersoData, referenceOrdreMission, searchLabelInEnumByValue } from '../../../Utils/utils';

const AllOrdreMissions = () => {
    const { addEuro4Decimal } = useNumberFormatting();
    const [open, setOpen] = useState(false);
    const [rowselected, setRowSelected] = useState();
    const { i18n } = useTranslation();
    const [selectedRow, setSelectedRow] = React.useState(null);
    const role = useRole();
    const [missions, setMissions] = useState([]);
    const [array, setArray] = useState([]);
    const { setBackdropOpen } = useUtilities();
    // ! il y a une repetitions sur certains fonctions, car on a desactive la fonction d'affichage dirrectement a partir du serveur, du coup il ya encore du travail sur ce modele, mais on le garde comme ca maintnt.
    // * client culumns for client function, we use function on the function itself : function = missions.reverse() ... with the loop
    // const ordreMissionColumns = [
    //     {
    //         field: 'refOrdreMission',
    //         title: 'Réf.Ordre de mission',
    //         // ? border Material table
    //     },
    //     {
    //         field: 'createdAt',
    //         title: 'Date d\'émission',
    //         render:  rowData =>
    //             formatDateJJMMYYYY(rowData?.createdAt),
    //     },
    //     {
    //         field: 'titre',
    //         title: 'Intitulé de la mission',
    //     },
    //     {
    //         field: 'statut',
    //         title: 'Statut',
    //         render:  rowData =>
    //             searchLabelInEnumByValue(StatutsOrdreMision,(rowData?.statut)),
    //     },
    //     {
    //         field: 'nomClient',
    //         title: 'Nom du client',
    //     },
    //     {
    //         field: 'dateDebutBdc',
    //         title: 'Date début BDC',
    //     },
    //     {
    //         field: 'dateFinBdc',
    //         title: 'Date fin BDC',
    //     },
    //     {
    //         field: 'dureebdc',
    //         title: 'Nb.jours BDC',
    //         render: rowData =>{
    //             return (addEuro4Decimal(rowData.dureebdc,' j'));
    //         }
    //     },
    //     {
    //         field: 'tauxJournalier',
    //         title: 'Taux journalier HT',
    //         render:  rowData =>{
    //             return addEuro4Decimal(rowData?.tauxJournalier);
    //         }
    //     },
    //     {
    //         field: 'chargerecrutement',
    //         title: 'Chargé de recrutement',
    //     },
    //     {
    //         field: 'responsableoper',
    //         title: 'Resp.Opérationnel',
    //     },
    // ];

    // * client culumns for server function (more traitemnts, all client function was imported directly here)
    const columns = [
        {
            field: 'refOrdreMission',
            title: i18n.t('Réf.Ordre de mission'),
            // ? border Material table
            render:  rowData =>
                referenceOrdreMission(rowData?.missionId),
        },
        {
            field: 'createdAt',
            title: i18n.t('Date d\'émission'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.createdAt),
        },
        {
            field: 'titre',
            title: i18n.t('Intitulé de la mission'),
        },
        {
            field: 'statut',
            title: i18n.t('Statut'),
            render:  rowData =>
                i18n.t(searchLabelInEnumByValue(StatutsOrdreMision,(rowData?.statut))),
        },
        ...(role=='esn' ?
            [{
                field: 'nomExpert',
                title: i18n.t('Nom d\'expert'),
                render:  rowData =>
                    getNomPrenomClearFromPersoData(rowData?.expertId?.persoData),
            }]:[]),
        {
            field: 'nomClient',
            title: i18n.t('Nom du client'),
            // render:  rowData =>
            //     rowData?.companyDataId?.profileEntreprise?.nom ??  rowData?.esnId?.profileEntreprise?.nom,
        },
        {
            field: 'dateDebutBdc',
            title: i18n.t('Date début BDC'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.BDCs[0]?.dateDebutBDC),
        },
        {
            field: 'dateFinBdc',
            title: i18n.t('Date fin BDC'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.BDCs[0]?.dateFinBDC),
        },
        {
            field: 'dureebdc',
            title: i18n.t('Nb.jours BDC'),
            render: rowData =>{
                return (addEuro4Decimal(rowData?.BDCs[0]?.nbJoursBDC ?? calculateWorkingDaysBetweenDates(rowData?.BDCs[0]?.dateDebutBDC, rowData?.BDCs[0]?.dateFinBDC),' j'));
            },
        },
        {
            field: 'tauxJournalier',
            title: i18n.t('Taux journalier HT'),
            render:  rowData =>{
                return addEuro4Decimal(rowData?.tauxJournalier);
            },
        },
        {
            field: 'chargerecrutement',
            title: i18n.t('Chargé de recrutement'),
            render:  rowData =>
                getNomPrenomClearFromPersoData(rowData?.BDCs[0]?.backOfficeId?.persoData),
        },
        {
            field: 'responsableoper',
            title: i18n.t('Resp.Opérationnel'),
            render:  rowData =>
                getNomPrenomClearFromPersoData(rowData?.BDCs[0]?.responsableOperationnelId?.persoData ?? rowData?.BDCs[0]?.responsableOperationnelEsnId?.persoData),
        },
        ...(role==='esn' ?
            [{
                field: 'commercial',
                title: i18n.t('Commercial'),
                render:  rowData =>
                    getNomPrenomClearFromPersoData(rowData?.BDCs[0]?.collaboratorEsnExpertId?.persoData)
            }]:[])
    ];

    const axiosPrivate = useAxiosPrivate();
    const handleClickOpen = async () => {
        setOpen(true);
    };

    // const [tableData, setTableData] = useState({ data: [], page: 0, totalCount: 0 });
    // const [tableKey, setTableKey] = useState(0); // Key to force re-render of the table

    const handleClose = async () => {
        // await fetchData(); // Refresh data upon closing dialog
        // setTableKey(prevKey => prevKey + 1); // Increment key to re-render table
        setOpen(false); // Close the dialog
        getOrdreMissions();
    };

    useEffect(() => {
        getOrdreMissions();
    }, []);
    useEffect(() => {
        if (missions) {
            let Array1 = [];
            console.log('test', missions);
            // * server function
            missions?.reverse().forEach((element) => {
                Array1.push({
                    id: element?._id,
                    createdAt: element?.BDCs[0]?.createdAt,
                    missionId: element?.missionId,
                    dateDebutMission: element?.dateDebutMission,
                    titre: element?.titre,
                    statut: element?.ordreDeMission?.statut,
                    motifRejet: element?.ordreDeMission?.motifRejet,
                    localisation: element?.localisation,
                    dateFinMission: element?.dateFinMission,
                    companyDataId: element?.companyDataId,
                    ordreDeMission: element?.ordreDeMission,
                    expert: element?.expertId,
                    nomClient: element?.companyDataId?.profileEntreprise?.nom ??  element?.esnId?.profileEntreprise?.nom,
                    BDCsOP: element.BDCs,
                    xx: element?.companyDataId?.donneeFacturation?.delaiPaiement,
                    aoId: element?.aoId,
                    expertId: element?.expertId,
                    tauxJournalier: element?.BDCs[0]?.tj,
                    // refOrdreMission: referenceOrdreMission(element?.missionId),
                    // dateDebutBdc: formatDateJJMMYYYY(element?.BDCs[0]?.dateDebutBDC),
                    // dateFinBdc: formatDateJJMMYYYY(element?.BDCs[0]?.dateFinBDC),
                    // dureebdc:calculateWorkingDaysBetweenDates(element?.BDCs[0]?.dateDebutBDC, element?.BDCs[0]?.dateFinBDC),
                    // responsableoper: getNomPrenomClearFromPersoData(element?.BDCs[0]?.responsableOperationnelId?.persoData),
                    // chargerecrutement: getNomPrenomClearFromPersoData(element?.BDCs[0]?.backOfficeId?.persoData),
                    ...element,
                });
            });
            // * client function
            // missions?.reverse().forEach(element => {
            //     Array1.push({
            //         'id': element?._id,
            //         // 'refOrdreMission': referenceOrdreMission(mission?.missionId),
            //         'refOrdreMission': referenceOrdreMission(element?.missionId),
            //         'createdAt': element?.BDCs[0]?.createdAt,
            //         'missionId':element?.missionId,
            //         'dateDebutMission':element?.dateDebutMission,
            //         'titre': element?.titre,
            //         'statut': element?.ordreDeMission?.statut,
            //         'motifRejet': element?.ordreDeMission?.motifRejet,
            //         'localisation':element?.localisation,
            //         'dateFinMission':element?.dateFinMission,
            //         'companyDataId':element?.companyDataId,
            //         'ordreDeMission':element?.ordreDeMission,
            //         'expert':element?.expertId,
            //         'nomClient': element?.companyDataId?.profileEntreprise?.nom,
            //         'BDCsOP':element.BDCs,
            //         'xx':element?.companyDataId?.donneeFacturation?.delaiPaiement,
            //         'aoId':element?.aoId,
            //         'expertId':element?.expertId,
            //         'dateDebutBdc': formatDateJJMMYYYY(element?.BDCs[0]?.dateDebutBDC),
            //         'dateFinBdc':formatDateJJMMYYYY(element?.BDCs[0]?.dateFinBDC),
            //         'dureebdc': calculateWorkingDaysBetweenDates(element?.BDCs[0]?.dateDebutBDC, element?.BDCs[0]?.dateFinBDC),
            //         'tauxJournalier': element?.BDCs[0]?.tj,
            //         'responsableoper': getNomPrenomClearFromPersoData(element?.BDCs[0]?.responsableOperationnelId?.persoData),
            //         'chargerecrutement': getNomPrenomClearFromPersoData(element?.BDCs[0]?.backOfficeId?.persoData),
            //         ...element
            //     });
            // });
            setArray(Array1);
            console.log(Array1, array);
        }
    }, [missions]);

    const getOrdreMissions = async () => {
        try {
            setBackdropOpen(true);
            console.log('HELLO FROM the get Missions useEffect');
            const response = await axiosPrivate.get('mission/ordreMissions', {
                // signal: controller.signal
            });
            console.log(response.data);
            setMissions(response.data);
            setBackdropOpen(false);
        } catch (error) {
            console.log(error);
            setBackdropOpen(false);
        }
    };
    // const fetchData = (query = { pageSize: 5, page: 0 }) => {
    //     return new Promise((resolve) => {
    //         let url = 'mission/ordreMissions?';
    //         url += 'per_page=' + query.pageSize;
    //         url += '&page=' + query.page;
    //         axiosPrivate.get(url)
    //             .then(result => {
    //                 const newData = {
    //                     data: result.data.data,
    //                     page: result.data.page,
    //                     totalCount: result.data.total,
    //                 };
    //                 // setTableData(newData); // Update tableData with fetched data
    //                 resolve(newData);
    //             })
    //             .catch(error => {
    //                 console.error('Error fetching mission data:', error);
    //                 const emptyData = {
    //                     data: [],
    //                     page: 0,
    //                     totalCount: 0,
    //                 };
    //                 // setTableData(emptyData); // Update tableData with fetched data
    //                 resolve(emptyData);
    //             });
    //     });
    // };
    // useEffect(() => {
    //     fetchData();
    // }, []);

    return (
        <>
            {role === 'esn'
                ? (
                    <div className='frame5Profile'>
                        {i18n.t('Gestion des missions-HTH')}
                        &gt;
                        <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Vente')}</span>
                        &gt;
                        <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Ordres de missions')}</span>
                    </div>
                )
                : (
                    <div className='frame5Profile'>
                        {i18n.t('Missions et BDC')}
                        &gt;
                        <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Ordres de missions')}</span>
                    </div>
                )
            }

            <div className="HomeFrame">
                <h4 className='titlesociete'>{i18n.t('Ordres de missions')}</h4>
                <MaterialTableComponent
                    // key={tableKey} // Use tableKey as the key
                    columns={columns}
                    data={array}
                    // data={fetchData}
                    title={i18n.t('Ordre de mission')}
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                        setRowSelected(rowData);
                        handleClickOpen();
                    }}
                    // options={{
                    //     showColumnsButton: true,
                    //     paging: true, // Enable paging
                    // }}
                    // onColumnsChange={(_, newColumns) => handleColumnsChange(newColumns)}
                    selectedRow={selectedRow}
                />
                {open &&
                <OrdreMission
                    handleClose={handleClose}
                    mission={rowselected}
                    open={open}
                />}
            </div>

        </>
    );
};

export default AllOrdreMissions;